import { render, staticRenderFns } from "./PostTile.vue?vue&type=template&id=af6c4c28&scoped=true"
import script from "./PostTile.vue?vue&type=script&lang=js"
export * from "./PostTile.vue?vue&type=script&lang=js"
import style0 from "./PostTile.vue?vue&type=style&index=0&id=af6c4c28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6c4c28",
  null
  
)

export default component.exports